/* =================== MINHA CONTA =================== */
jQuery(document).ready(function ($) {
  // Exibe a confirmação ao clicar no botão de remover
  $(".btn-confirm").on("click", function (e) {
    e.preventDefault();
    var idRemove = $(this).data("id");
    $("#id_remove").val(idRemove);
    openModal("modal-confirm");
  });

  // Exibe a confirmação ao clicar no botão de cancelar plano
  $(".btn-cancela").on("click", function (e) {
    e.preventDefault();
    var idCancela = $(this).data("id");
    $("#id_cancela").val(idCancela);
    openModal("modal-cancelar");
  });

  // Exibe/Oculta os campos da forma de pagamento escolhida
  $('input[name="forma-pagamento"]').on("change", function () {
    $(".forma-pag-content").slideUp();
    $(".forma-pag-content .campo").prop("disabled", true);
    $(".forma-pag-content .campo").prop("required", false);

    $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "disabled",
      false
    );
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "required",
      true
    );
  });

  // ------------------------------------
  // Ezdz (Upload de imagem única)
  // ------------------------------------
  (function () {
    "use strict";

    // Campos
    const $inputs = $("input.ezdz");

    // Aplica o plugin nos campos
    $inputs.each(function () {
      // Variáveis
      const $input = $(this);
      let $dropzone;
      const text = $input.data("ezdz-text")
        ? $input.data("ezdz-text")
        : "Selecionar imagem";
      const maxWidth = $input.data("ezdz-maxwidth")
        ? parseInt($input.data("ezdz-maxwidth"))
        : null;
      const maxHeight = $input.data("ezdz-maxheight")
        ? parseInt($input.data("ezdz-maxheight"))
        : null;
      const maxSizeMb = $input.data("ezdz-maxsize")
        ? parseInt($input.data("ezdz-maxsize"))
        : 10;
      // Mensagens de erro
      const messagesList = {
        mimeType: "Selecione uma imagem válida.",
        maxSize: `A imagem não deve ser maior que ${maxSizeMb} MB.`,
        maxWidth: `Selecione uma imagem com até ${maxWidth}px de largura.`,
        maxHeight: `Selecione uma imagem com até ${maxHeight}px de altura.`,
      };

      // Converte MB em Bytes
      const maxSize = maxSizeMb * 1048576;

      // Aplica o plugin ao campo
      $input.ezdz({
        text: text, // Texto
        validators: {
          maxSize: maxSize, // Tamanho máximo (MB)
          maxWidth: maxWidth, // Largura máxima
          maxHeight: maxHeight, // Altura máxima
        },
        // Inicializa o plugin
        init: function () {
          $dropzone = $input.parent(".ezdz-dropzone");
        },
        // Imagem inválida
        reject: function (file, errors) {
          const error = getEzdzError(messagesList, errors);
          $dropzone.addClass("ezdz-reject");
          $input.parsley().removeError("ezdz-error", { updateClass: true });
          $input
            .parsley()
            .addError("ezdz-error", { message: error, updateClass: true });
        },
        // Imagem válida
        accept: function (file) {
          $dropzone.removeClass("ezdz-reject");
          $input.parsley().removeError("ezdz-error", { updateClass: true });
        },
      });
    });

    // Retorna a mensagem relacionada ao erro
    function getEzdzError(messagesList, errosList) {
      for (let error in errosList) {
        if (errosList[error]) {
          return messagesList[error];
        }
      }
      return false;
    }
  })();
});
